import * as api from './middleware/api.middleware';
import {
    ICreateFolder,
    IUpdateFolder,
    IDeleteFolder,
    IFolder,
    ICreateFolderResponse,
} from '../interfaces/folder.interfaces';
import { IResponseCollection } from '../interfaces/general.interfaces';
import { buildQueryParamsStringFromType } from '../helpers/general';
import { getMiddlewareOptionsWithContext } from './middleware/helpers';
import { ErrorContext } from '../enums';

const serviceUrl = '/mailboxservice/v2';

export function createFolder(folderData: ICreateFolder, context?: ErrorContext) {
    const url = `${serviceUrl}/folders/`;
    const data = {
        mailboxId: folderData.mailboxId,
        name: folderData.name,
        parentId: folderData.parentFolderId,
    };
    return api.post<ICreateFolderResponse>(url, data, null, getMiddlewareOptionsWithContext(context));
}

export function getFolders(mailboxId: string) {
    const queryParams = ['mailboxId=' + mailboxId];
    const url = serviceUrl + '/folders?' + queryParams.join('&');
    return api.get<IResponseCollection<IFolder>>(url);
}

export function deleteFolder(mailboxId: string, folderId: string, requestData?: IDeleteFolder, context?: ErrorContext) {
    let url = `${serviceUrl}/folders/${mailboxId}/deletefolder/${folderId}?`;
    if (requestData) url = url + buildQueryParamsStringFromType<IDeleteFolder>(requestData);
    return api.del<any>(url, null, null, getMiddlewareOptionsWithContext(context));
}

export function moveFolder(folderData: IUpdateFolder, context?: ErrorContext) {
    const url = `${serviceUrl}/folders/${folderData.mailboxId}/move/${folderData.folderId}`;
    const data = {
        parentId: folderData.parentId,
        folderType: folderData.folderType,
        version: folderData.version,
        name: folderData.name,
    };
    return api.post<any>(url, data, null, getMiddlewareOptionsWithContext(context));
}

export function renameFolder(folderData: IUpdateFolder, context?: ErrorContext) {
    const url = `${serviceUrl}/folders/${folderData.mailboxId}/rename/${folderData.folderId}`;
    const data = {
        parentId: folderData.parentId,
        name: folderData.name,
        folderType: folderData.folderType,
        version: folderData.version,
    };
    return api.post<any>(url, data, null, getMiddlewareOptionsWithContext(context));
}
